RivalIQ.apps.Dashboard.module('mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    const MAX_SEARCH_CHARS = 500;

    mixins.SearchableLayout = {

        getErrorElement: function () {
            const me = this;
            return me.ui.noPosts;
        },

        getMessageForError: function (error) {
            let errorMessage = '';
            const errorName = error.errorName || error.name;

            switch (errorName) {
                case 'BadSearchSyntaxError':
                    errorMessage = 'Your search syntax is invalid. Try another search or <a href="http://help.rivaliq.com/user-guides/social-post-search-tips" target="_blank">view more search tips</a>.';
                    break;
                case 'InvalidDateError': {
                    errorMessage = `I'm sorry, but there is a time zone conflict with your data.`;
                    if (error.invalidDate) {
                        errorMessage += ` Please change the ${moment.utc(error.invalidDate).format('ll')} date in the date range or change your time zone.`;
                    }
                    break;
                }
                case 'SearchQueryTooLongError':
                    errorMessage = `Oops! This query must be under ${MAX_SEARCH_CHARS} characters.`;
                    break;
                default:
                    errorMessage = 'Oops! An error has occurred.';
            }

            return errorMessage;
        },

        toggleView: function (error, metric) {
            const me = this;
            me.requestRenderedFrame(function () {
                if (error) {
                    const errMsg = me.getMessageForError(error);
                    const shouldHideTryAgainMsg = _.includes(['SearchQueryTooLongError', 'InvalidDateError'], error.errorName);
                    me.showTryAgainMessage(errMsg, shouldHideTryAgainMsg);
                    me[me.widgetRegion].$el.hide();
                } else if (metric && metric.getValue({
                    format: false
                }) === 0) {
                    me.showNoPostsMessage();
                    me[me.widgetRegion].$el.hide();
                } else {
                    me.getErrorElement().hide();
                    me[me.widgetRegion].$el.show();
                }
            });
        },
        showNoPostsMessage: function () {
            const me = this;
            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            me.showTryAgainMessage(`There were no matching ${postWord}s in your landscape.`);
        },
        showTryAgainMessage: function (message, hideTryAgain) {
            const me = this;
            const View = me.getSearchableErrorView();

            const errorElement = me.getErrorElement();
            new View({
                el: errorElement,
                model: new Backbone.Model({
                    message: message,
                    hideTryAgain: hideTryAgain
                })
            }).render();
            errorElement.show();
        },
        getSearchableErrorView: function () {
            return RivalIQ.views.ItemView.extend({
                template: '#dashboardSearchableLayoutErrorTemplate'
            });
        }
    };

});
